import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'asistencia-reporte-direccion-academica-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <h1 class="control-item">Asistencia</h1>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">Reporte dirección académica</h1>
            <span class="spacer"></span>
        </div>`
})

export class AsistenciaReporteDireccionAcademicaBarraComponent implements OnInit {


    constructor() {
    }

    ngOnInit() {
    }
}